import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Feature, FeatureCreate, FeatureFilter } from '../data/feature';

export function createFeatureService(client: AxiosInstance) {
  return createCrudService<Feature, FeatureCreate, FeatureFilter>(client, '/Feature', 'featureId');
}

export type FeatureService = CrudService<Feature, FeatureCreate, FeatureFilter>;
